import { render, staticRenderFns } from "./customer-wall.vue?vue&type=template&id=6d16cb50&scoped=true"
import script from "./customer-wall.vue?vue&type=script&lang=js"
export * from "./customer-wall.vue?vue&type=script&lang=js"
import style0 from "./customer-wall.vue?vue&type=style&index=0&id=6d16cb50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_nd5b4b5ys5eo7bulp7f5cn4bfu/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d16cb50",
  null
  
)

export default component.exports